/**
 * Los checks de WhatsApp para una LISTA de conversaciones.
 *
 * 🪤 EXISTE PORQUE ESTABA ENCERRADO. Vivía como función privada dentro de `WaConversationList.tsx`,
 * así que el menú de chats del encabezado —que muestra la misma lista— no podía usarlo. La opción
 * fácil era copiarlo, y ahí empieza la divergencia: un lado aprende un estado nuevo (`failed`, por
 * ejemplo) y el otro se queda mostrando el reloj de arena para siempre, sin que nadie lo note porque
 * los dos "funcionan".
 *
 * 🪤 Y NO SIRVE EL COMPONENTE DE CHECKS DEL HILO. Ese es más grande y con más aire, pensado para ir
 * pegado a la burbuja de un mensaje. En una fila de lista de 40 px compite con el nombre y la hora.
 * Son dos usos distintos del mismo concepto y por eso son dos componentes — no es duplicación.
 *
 * Los colores salen del WhatsApp real: el doble check azul es #53bdeb y ahí se apoya toda la
 * expectativa del usuario. Están a mano en vez de venir de un token de Polaris porque no describen
 * el estado de la interfaz, imitan una marca ajena que el usuario ya reconoce.
 */

/** Estados que reporta el proveedor, del más viejo al más nuevo. */
export type EstadoDeEntrega = 'pending' | 'sent' | 'delivered' | 'read' | 'failed' | string;

export function WaDeliveryTicks({ status }: { status: EstadoDeEntrega }) {
  if (status === 'read') {
    return <span style={{ color: '#53bdeb', fontSize: 14, letterSpacing: -3, flexShrink: 0 }}>✓✓</span>;
  }
  if (status === 'delivered') {
    return <span style={{ color: '#8696a0', fontSize: 14, letterSpacing: -3, flexShrink: 0 }}>✓✓</span>;
  }
  if (status === 'sent') {
    return <span style={{ color: '#8696a0', fontSize: 14, flexShrink: 0 }}>✓</span>;
  }
  if (status === 'failed') {
    return <span style={{ color: '#ea4335', fontSize: 13, flexShrink: 0 }}>✗</span>;
  }
  // Encolado o desconocido: el reloj de arena dice "todavía no salió" sin prometer que salió.
  return <span style={{ color: '#8696a0', fontSize: 11, flexShrink: 0 }}>⏳</span>;
}
